import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class IsSisenseRefresh {
  constructor({ value }) {
    this.value = value
    this.errorMessage = (
      <FormattedMessage id="invalid_refresh_trigger_interval" />
    )
  }

  validate() {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(this.value) || this.value < 60 || this.value > 2147483647) {
      return this.errorMessage
    }

    return null
  }
}
